export const CONFIG = {
    SITE_NAME: 'AOTdle',
    SITE_URL: 'https://aotdle.com',
    SITE_DESCRIPTION: 'Daily Attack on Titan character guessing game',
    VERSION: '1.0.0',

    // Google AdSense Publisher ID
    ADSENSE_CLIENT: 'ca-pub-8734899967485481',

    // Contact
    CONTACT_EMAIL: 'hello@aotdle.com',

    // Storage keys
    STORAGE_KEYS: {
        STATS: 'aotdle-stats',
        GAME_STATE: 'aotdle-game-state',
        LANGUAGE: 'aotdle-language',
        SETTINGS: 'aotdle-settings',
        COOKIE_CONSENT: 'aotdle-cookie-consent'
    }
};
